import { useContrastQuery } from '../../../../hooks/use-contrast-query'
import { Query } from '../../../../hooks/queries'
import {
  getApplications,
  GetApplicationsArgs
} from './requests/get-applications'
import { Application } from './shared'
import { HTTPError } from '../../../../api/fetch/decorate-fetch'

export interface UseApplicationsQueryProps {
  organizationUuid: string
}

export interface ApplicationsQueryResponse {
  applications: Application[] | undefined
  error: HTTPError | null
  isError: boolean
  isLoading: boolean
}

export type UseApplicationsQuery = (
  props: UseApplicationsQueryProps
) => ApplicationsQueryResponse

export const useApplicationsQuery: UseApplicationsQuery = ({
  organizationUuid
}: UseApplicationsQueryProps) => {
  const {
    data: applications,
    error,
    isError,
    isLoading
  } = useContrastQuery<GetApplicationsArgs, Application[]>(
    [Query.INTEGRATIONS_APPLICATIONS, organizationUuid],
    getApplications,
    {
      organizationUuid
    }
  )

  return {
    applications,
    error,
    isError,
    isLoading
  }
}
